<div [@inOutAnimation] class="mx-auto py-6 px-4 sm:px-6 lg:px-8">
    <table class="min-w-full divide-y divide-gray-200">
        <thead class="border-bottom">
            <tr class="border-top">
                <th sortableColumn="productionDate" scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <div class="whitespace-pre inline-flex">
                        Production Date
                        <span>
                            <sortIcon field="productionDate"></sortIcon>
                        </span>
                    </div>
                </th>

                <th sortableColumn="taxDoc" scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <div class="whitespace-pre inline-flex">
                        Tax Doc
                        <span>
                            <sortIcon field="taxDoc"></sortIcon>
                        </span>
                    </div>
                </th>

                <th sortableColumn="taxYear" scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    <div class="whitespace-pre inline-flex">
                        Tax Year 
                        <span>
                            <sortIcon field="taxYear"></sortIcon>
                        </span>
                    </div>
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    # Indexed
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    # Paper Delivery
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    # E-Delivery
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Entered By
                </th>

                <th scope="col"
                    class="px-6 py-3 bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Sent
                </th>
            </tr>
        </thead>
        <tbody *ngIf="loading" class="bg-white divide-y divide-gray-200">
            <tr>
                <td colspan="9">
                    <div *ngIf="loading" class="flex justify-center p-4 text-sm text-gray-500 animate-pulse">
                        <span>Loading...</span>
                    </div>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="error" class="bg-white divide-y divide-gray-200">
            <tr>
                <td class="pb-6" colspan="9">
                    <app-message severity="error"></app-message>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="!loading" class="bg-white divide-y divide-gray-200">
            <tr *ngFor="let taxDocSummary of rows" class="border-top">
                <td class="px-6 py-4 whitespace-nowrap">
                    <a [routerLink]="[ 'details', taxDocSummary.loadId]">
                        {{taxDocSummary.productionDate | date:'short'}}
                    </a>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocSummary.taxDoc}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocSummary.taxYear}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocSummary.indexedCount}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocSummary.paperDeliveryCount}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocSummary.electronicDeliveryCount}}</td>
                <td class="px-6 py-4 whitespace-nowrap">{{taxDocSummary.keyFormat}}</td>
                <td *ngIf="taxDocSummary.sent" class="px-6 py-4 whitespace-nowrap">Y</td>
                <td *ngIf="!taxDocSummary.sent"class="px-6 py-4 whitespace-nowrap">N</td>
            </tr>
        </tbody>
    </table>
</div>